import { ConnectRequestParams, Network } from '@puzzlehq/sdk';

export function getDistanceKm(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
) {
  const R = 6378; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  return Math.round(d);
}

export function deg2rad(deg: number) {
  return deg * (Math.PI / 180);
}

const roundPhrases = [
  'Better luck next time.',
  "You're getting warmer.",
  'Close, but not quite.',
  'Almost there!',
  'Great job!',
  'Spot on!',
];

export const roundPhrase = (score: number) => {
  if (![0, 1, 2, 3, 4, 5].includes(score)) return 'Nice work';
  return roundPhrases[score];
};

const gamePhrases = [
  'Missed it!',
  'Almost!',
  'OK!',
  'Nice try!',
  'Nice work!',
  'Impressive!',
  'Genius!',
];

export const gamePhrase = (score: number) => {
  if (score === 0) return gamePhrases[0];
  if (score < 3) return gamePhrases[1];
  if (score < 6) return gamePhrases[2];
  if (score < 9) return gamePhrases[3];
  if (score < 12) return gamePhrases[4];
  if (score < 15) return gamePhrases[5];
  if (score === 15) return gamePhrases[6];
};

const network: Network = import.meta.env.VITE_NETWORK!;

export const connectRequest: ConnectRequestParams = {
  dAppInfo: {
    description: 'A game of geography and mystery',
    name: 'Mystery City',
  },
  permissions: {
    programIds: {
      [network]: [
        import.meta.env.VITE_MYSTERY_CITY_CONTRACT!,
        import.meta.env.VITE_COIN_CONTRACT!,
        import.meta.env.VITE_TICKET_CONTRACT!,
      ],
    },
  },
};

export const MYSTERY_CITY_AUDIO_BASE_URL =
  'https://storage.googleapis.com/bucket-quickstart_jigsaw-bigshot/MysteryCity/audio';
